import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

const LogoutDialog = ({
  open,
  onClose,
  onLogout,
  onStayLoggedIn,
  timeRemaining, // initial value
}) => {
  const [timer, setTimer] = useState(timeRemaining);

  // Reset timer whenever dialog opens or timeRemaining changes
  useEffect(() => {
    if (open) {
      setTimer(timeRemaining);
    }
  }, [open, timeRemaining]);

  // Countdown logic
  useEffect(() => {
    if (!open || timer <= 0) return;

    const interval = setInterval(() => {
      setTimer((prev) => prev - 1000);
    }, 1000);

    return () => clearInterval(interval);
  }, [open, timer]);

  const minutes = Math.floor(timer / 60000);
  const seconds = Math.floor((timer % 60000) / 1000);
  const formattedSeconds = String(seconds).padStart(2, "0");

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ textAlign: "center" }}>
        Session Timeout Warning
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          For your security, your session will timeout in{" "}
          <b>
            {minutes} : {formattedSeconds} minutes
          </b>{" "}
          due to inactivity. Do you want to stay logged in or log out?
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onLogout} color="primary" variant="outlined">
          Logout
        </Button>
        <Button onClick={onStayLoggedIn} color="primary" variant="contained">
          Stay Logged In
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutDialog;
